import $ from "jquery";

const additionalRepeater = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-additional-repeater",
            buttonMain: ".js-additional-repeater__main",
            btnRemove:
                ".js-additional-repeater .js-additional-repeater__remove",
            btnAdd: ".js-additional-repeater .js-additional-repeater__add",
            btnAddOutside:
                ".js-additional-repeater .js-additional-repeater__outside",
            selectAcc:
                ".js-additional-repeater .js-additional-repeater__select-add",
            template: ".js-additional-repeater__template",
        };

        if ($(el.button).length === 0) return;

        $(document).on("click", el.buttonMain, function (e) {
            e.preventDefault();

            const target = $(this).data("target");
            $(this).removeClass("active");
            const htmlTemplate = $(el.template).html();

            const htmlVal = htmlTemplate.replace(/{{index}}/g, 1);

            $(`#${target}`).append(htmlVal);
            $(`#${target}`).addClass("active");
            $(el.btnAdd).addClass("active");
        });

        $(document).on("click", el.btnRemove, function (e) {
            e.preventDefault();

            const target = $(this).data("target");
            const targetArr = target.split("-");
            const targetWithoutIndex = targetArr[0] + "-" + targetArr[1];

            const parentTarget = `.Additional__Input--${targetWithoutIndex} .Additional__Input__Wrapper:not(:first-child)`;

            if ($(parentTarget).length === 1) {
                $(`#input-${targetWithoutIndex}`).removeClass("active");
                $(`#placeholder-${targetWithoutIndex}`).addClass("active");
            } else {
                if ($(parentTarget).length === 2) {
                    const _elOutside = `${el.btnAddOutside}[data-target="${targetWithoutIndex}"]`;
                    const _elAdd = `${el.btnAdd}[data-target="${targetWithoutIndex}"]`;

                    $(_elOutside).removeClass("active");
                    $(_elAdd).addClass("active");
                }
            }
            $(`#input-${target}`).remove();
        });

        $(document).on("change", el.selectAcc, function () {
            const optionVal = $(this).find("option:selected").val();
            const currId = $(this).attr("id");
            const currIdArr = currId.split("-");
            const currIndex = currIdArr[3];
            const classOtherAccEl = `.js-additional-repeater__other#additional-accessories-others-${currIndex}`;
            const otherAccEl = $(classOtherAccEl);

            if (optionVal == "anders") {
                $(otherAccEl).show();
                $(otherAccEl).prop("required", true);
            } else {
                $(otherAccEl).hide();
                $(otherAccEl).removeAttr("required");
            }
        });

        $(document).on(
            "click",
            [el.btnAdd, el.btnAddOutside].join(","),
            function (e) {
                e.preventDefault();

                const target = $(this).data("target");
                const lastIndexSelector = `#input-${target} > .Additional__Input__Wrapper:last-child`;
                const lastIndex = $(lastIndexSelector).data("index");
                const listItemTemplate = $(this)
                    .parent()
                    .parent()
                    .find(el.template)
                    .html();

                if (!listItemTemplate) return;

                const listItem = listItemTemplate.replace(
                    /{{index}}/g,
                    lastIndex + 1,
                );

                const parentTargetSelector = $(`#input-${target}`);

                $(parentTargetSelector).append(listItem);
                $(`${el.btnAddOutside}[data-target="${target}"]`).addClass(
                    "active",
                );
                $(`${el.btnAdd}[data-target="${target}"]`).removeClass(
                    "active",
                );
            },
        );

        $(window).on("load", function () {
            const parentTarget = `.Additional__Input__Wrapper:not(:first-child)`;
            if ($(parentTarget).length <= 1) {
                $(el.btnAddOutside).removeClass("active");
            }

            $("#input-additional-accessories").addClass("active");
        });
    };
    init();
};

try {
    additionalRepeater();
} catch (error) {
    console.error("additionalRepeater", error);
}
